import { Box } from '@mui/material';

export interface IdeaCardContentProps {
  showBackground: boolean;
  showPadding: boolean;
  children: React.ReactNode;
}

const IdeaCardContent = ({ showBackground, showPadding, children }: IdeaCardContentProps) => {
  return (
    <Box
      sx={
        showBackground
          ? {
              backgroundColor: '#F0F2F5',
              p: showPadding ? 1.5 : 0,
              borderRadius: 1,
              display: 'flex',
              flexDirection: 'column',
            }
          : null
      }
    >
      {children}
    </Box>
  );
};

export default IdeaCardContent;
